module.exports = __webpack_public_path__ + "assets/img/Apple-IOS-Store-Download.2fe49b08.png";